import AmexResyValueResyAmex from './AmexResyValueRelationship';

export default AmexResyValueResyAmex;
